<template>
  <div>
    <Row>
      <Col
        span="12"
        v-for="db in dbType"
        :key="db.title"
        style=" padding: 0 10px;"
      >
        <Card
          style="margin-bottom:20px;  "
          :key="db.title"
          :class="{
            'can-click': db.type,
            'disabled-bg': !db.action
          }"
          @click="createDb(db)"
        >
          <CardColumn width="60px" center>
            <Icon :className="db.icon" size="large" style="font-size: 45px;" />
          </CardColumn>
          <CardColumn center style="min-height:150px;">
            <div style="display: block;min-height:58px;">
              <div v-if="db.action" class="c-main-title">
                {{ db.title }}
              </div>
              <div class="c-main-title-black" v-else>
                {{ db.title }}
              </div>
              <div style="font-size:12px;min-width:182px;">
                {{ db.subTitle }}
              </div>
            </div>
          </CardColumn>
          <CardColumn width="120px;min-width:24px;" center>
            <div>
              <Button
                style=" width:80px;   margin-bottom: 5px;"
                size="small"
                type="secondary"
                @click.stop="goLink(db.link)"
                >服务介绍</Button
              ><br />
              <Button
                style=" width:80px;"
                :disabled="!db.action"
                type="secondary"
                size="small"
                >创建数据库</Button
              >
            </div>
          </CardColumn>
        </Card>
      </Col>
    </Row>
  </div>
</template>
<script>
import { BASE_INFO } from '@/apis/meta-data';
import { Card, CardColumn } from 'kpc/components/card';
import Icon from 'kpc/components/icon';
import Button from 'kpc/components/button';
import { Row, Col } from 'kpc/components/grid';

export default {
  name: 'dbInstruction',
  data() {
    return {
      // 数据库类型描述
      dbType: BASE_INFO.dbType
    };
  },
  components: {
    Card,
    CardColumn,
    Icon,
    Row,
    Col,
    Button
  },
  methods: {
    createDb(db) {
      this.$emit('create-db', db);
    },
    goLink(link) {
      if (link) {
        window.open(link, '_blank');
      }
    }
  }
};
</script>
